export default __webpack_public_path__ + "99a2eb392e1694b2f5477515a4c0c7ef.png";